module.exports = __webpack_public_path__ + "static/media/icon5.64575fc9.png";